import React from 'react';

/* Authentic-style Adinkra symbols rendered as bold SVG paths.
   Each symbol is drawn in its traditional proportions. */

export const GyeNyame = ({ size = 100, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
    {/* Gye Nyame — "Except for God" — a curved crown-like flame */}
    <path
      d="M60 12 C 40 12, 22 28, 22 52 C 22 74, 38 88, 58 92 L58 108 L62 108 L62 92 C 82 88, 98 74, 98 52 C 98 28, 80 12, 60 12 Z"
      stroke={color}
      strokeWidth="5"
      fill="none"
      strokeLinejoin="round"
    />
    <path
      d="M40 45 C 40 35, 48 28, 60 28 C 72 28, 80 35, 80 45 C 80 55, 72 60, 60 60 C 48 60, 40 55, 40 45 Z"
      stroke={color}
      strokeWidth="4"
      fill="none"
    />
    <circle cx="60" cy="45" r="6" fill={color} />
    <path d="M32 60 Q 40 72, 50 76 M88 60 Q 80 72, 70 76" stroke={color} strokeWidth="4" fill="none" strokeLinecap="round" />
  </svg>
);

export const Sankofa = ({ size = 100, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
    {/* Sankofa — bird looking backward, heart-shape variant */}
    <path
      d="M60 15 C 40 15, 25 30, 25 55 C 25 75, 40 90, 60 108 C 80 90, 95 75, 95 55 C 95 30, 80 15, 60 15 Z"
      stroke={color}
      strokeWidth="5"
      fill="none"
      strokeLinejoin="round"
    />
    <path
      d="M60 32 C 48 32, 40 42, 40 55 C 40 68, 48 76, 60 80 C 72 76, 80 68, 80 55 C 80 42, 72 32, 60 32 Z"
      stroke={color}
      strokeWidth="3.5"
      fill="none"
    />
    <circle cx="60" cy="55" r="5" fill={color} />
    <path d="M50 95 L60 108 L70 95" stroke={color} strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DwennimmenAdinkra = ({ size = 100, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
    {/* Dwennimmen — Ram's horns — humility and strength */}
    <path
      d="M30 40 C 20 40, 15 55, 25 68 C 35 78, 45 72, 45 60 C 45 50, 40 40, 30 40 Z"
      stroke={color} strokeWidth="5" fill="none" strokeLinejoin="round"
    />
    <path
      d="M90 40 C 100 40, 105 55, 95 68 C 85 78, 75 72, 75 60 C 75 50, 80 40, 90 40 Z"
      stroke={color} strokeWidth="5" fill="none" strokeLinejoin="round"
    />
    <path d="M45 60 L45 85 M75 60 L75 85" stroke={color} strokeWidth="5" strokeLinecap="round" />
    <path d="M40 85 L80 85" stroke={color} strokeWidth="5" strokeLinecap="round" />
    <circle cx="35" cy="55" r="3" fill={color} />
    <circle cx="85" cy="55" r="3" fill={color} />
  </svg>
);

export const AkomaNtoaso = ({ size = 100, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
    {/* Akoma Ntoaso — Linked hearts — understanding and agreement */}
    <path
      d="M35 55 C 25 45, 25 30, 40 30 C 48 30, 52 38, 52 45 C 52 60, 40 75, 40 75 C 40 75, 35 65, 35 55 Z"
      stroke={color} strokeWidth="4.5" fill="none" strokeLinejoin="round"
    />
    <path
      d="M85 55 C 95 45, 95 30, 80 30 C 72 30, 68 38, 68 45 C 68 60, 80 75, 80 75 C 80 75, 85 65, 85 55 Z"
      stroke={color} strokeWidth="4.5" fill="none" strokeLinejoin="round"
    />
    <path d="M52 52 L68 52" stroke={color} strokeWidth="5" strokeLinecap="round" />
    <circle cx="60" cy="52" r="4" fill={color} />
    <path d="M40 78 L40 95 M80 78 L80 95" stroke={color} strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Adinkrahene = ({ size = 100, color = "#C9A84C" }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
    {/* Adinkrahene — Chief of Adinkra symbols — three concentric circles, leadership */}
    <circle cx="60" cy="60" r="48" stroke={color} strokeWidth="5" fill="none" />
    <circle cx="60" cy="60" r="32" stroke={color} strokeWidth="5" fill="none" />
    <circle cx="60" cy="60" r="16" stroke={color} strokeWidth="5" fill="none" />
    <circle cx="60" cy="60" r="5" fill={color} />
  </svg>
);
